import React from 'react';
import {EXTRACT_KEYWORD_DICTS} from "@app/constants/Dicts";
import DictItems from "@pages/dictionary/DictItems";

const DictKeywordList = () => {
    return (
        <div className="container-fluid">
            <div className="card card-primary">
                <div className="card-header">
                    <h3 className="card-title">Danh sách từ khóa</h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        {EXTRACT_KEYWORD_DICTS.map(item => (
                            <div className="col-sm-4">
                                <DictItems dictType={item.type} title={item.title}/>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DictKeywordList;
